import { TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";

interface WelcomeStepProps {
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  return (
    <div className="flex flex-col items-center text-center space-y-6 py-8">
      <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
        <TrendingUp className="h-8 w-8 text-primary" />
      </div>

      <div className="space-y-3">
        <h2 className="text-2xl font-bold tracking-tight">
          Bem-vindo ao Next AI Finance!
        </h2>
        <p className="text-muted-foreground max-w-md">
          Sua plataforma inteligente de gestão financeira pessoal.
          Organize suas contas, acompanhe seus gastos e alcance seus objetivos
          financeiros com a ajuda de inteligência artificial.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-lg pt-4">
        <div className="flex flex-col items-center p-4 rounded-lg bg-muted/50">
          <span className="text-2xl mb-2">📊</span>
          <span className="text-sm font-medium">Controle total</span>
          <span className="text-xs text-muted-foreground">das suas finanças</span>
        </div>
        <div className="flex flex-col items-center p-4 rounded-lg bg-muted/50">
          <span className="text-2xl mb-2">🤖</span>
          <span className="text-sm font-medium">IA integrada</span>
          <span className="text-xs text-muted-foreground">análises inteligentes</span>
        </div>
        <div className="flex flex-col items-center p-4 rounded-lg bg-muted/50">
          <span className="text-2xl mb-2">🎯</span>
          <span className="text-sm font-medium">Metas claras</span>
          <span className="text-xs text-muted-foreground">objetivos atingíveis</span>
        </div>
      </div>

      <Button onClick={onNext} size="lg" className="mt-6">
        Próximo
      </Button>
    </div>
  );
}
